import {
  ADD_UPDATE_ECOLAB_ITEMDETAILS_FAILURE,
  ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST,
  ADD_UPDATE_ECOLAB_ITEMDETAILS_SUCCESS,
  FETCH_ECOLAB_ITEMDETAILS_LIST_FAILURE,
  FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST,
  FETCH_ECOLAB_ITEMDETAILS_LIST_SUCCESS
} from "./actionTypes";
import { EcolabItemDetailsState } from "./types";

// Initial state for item reducer
const initialItemDetailsState: EcolabItemDetailsState = {
    ecolabItemDetailsList: [],
    loading: false,
    error: null,
    totalCount: 0,
    successMessage: null
};
//Item details reducer
const ecolabItemDetailsReducer = (
  state = initialItemDetailsState,
  action: any
): EcolabItemDetailsState => {
  switch (action.type) {
    case FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ECOLAB_ITEMDETAILS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        ecolabItemDetailsList: action.payload.ecolabItemDetailsList || action.payload,
        totalCount: action.payload.totalCount || 0,
      };

    case FETCH_ECOLAB_ITEMDETAILS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_UPDATE_ECOLAB_ITEMDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
      };

    case ADD_UPDATE_ECOLAB_ITEMDETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ecolabItemDetailsReducer;